var map = {
	"./add-driver.svg": "1e60",
	"./add-outline.svg": "7be7",
	"./add-package.svg": "6c95",
	"./add-truck.svg": "e4d4",
	"./add.svg": "76a4",
	"./address.svg": "e8fc",
	"./arrow-right.svg": "cd8c",
	"./attachment.svg": "3e0e",
	"./bank.svg": "02f2",
	"./barcode.svg": "b632",
	"./birthday.svg": "1e3b",
	"./calendar-alt.svg": "c27f",
	"./calendar.svg": "b8bd",
	"./cancel.svg": "b463",
	"./check-alt.svg": "e409",
	"./check.svg": "7bae",
	"./chevron-down-alt.svg": "2ccb",
	"./chevron-down.svg": "1755",
	"./chevron-left-alt.svg": "6b03",
	"./chevron-right-alt.svg": "f962",
	"./chevron-up-alt.svg": "2453",
	"./chevron-up.svg": "bb5d",
	"./clock.svg": "755b",
	"./close-alt.svg": "aa30",
	"./close-circle.svg": "1cfc",
	"./close.svg": "8b1b",
	"./cnh.svg": "66b5",
	"./comment.svg": "c47d",
	"./copy.svg": "8aac",
	"./cpf.svg": "543a",
	"./dashboard-package-delivery-alt.svg": "4017",
	"./dashboard-package-request-fail.svg": "3482",
	"./dashboard-package-request.svg": "3d61",
	"./dashboard-profile-driver-question.svg": "903e",
	"./dashboard-status-alt.svg": "adbe",
	"./dashboard-status-bad.svg": "0c9b",
	"./dashboard-store-sleep.svg": "bfa6",
	"./dashboard-theft.svg": "7e9b",
	"./dashboard-truck-delivered.svg": "9367",
	"./dashboard-truck-document.svg": "5a3b",
	"./dashboard-truck-ongoing.svg": "aaf5",
	"./dashboard-truck-question.svg": "f21a",
	"./dashboard.svg": "ecef",
	"./deadline.svg": "3d03",
	"./document.svg": "4aa0",
	"./download-alt.svg": "61c8",
	"./download.svg": "f28e",
	"./driver.svg": "345c",
	"./edit-alt-2.svg": "bc2e",
	"./edit-alt.svg": "91e1",
	"./edit.svg": "daf0",
	"./elipses.svg": "01a0",
	"./email.svg": "43be",
	"./error.svg": "28c3",
	"./exclamation-alt.svg": "7fcc",
	"./exclamation-circle.svg": "8128",
	"./exclamation.svg": "177c",
	"./exit.svg": "a2ab",
	"./export-alt.svg": "2266",
	"./export.svg": "1578",
	"./eye.svg": "7364",
	"./facebook.svg": "8485",
	"./faq.svg": "59f6",
	"./file-default.svg": "4bb8",
	"./file-pdf.svg": "d890",
	"./file-ppt.svg": "23a3",
	"./file-pptx.svg": "5975",
	"./file-xls.svg": "846e",
	"./file-xlsx.svg": "f767",
	"./filter.svg": "2376",
	"./fullscreen-close.svg": "1915",
	"./fullscreen-open.svg": "acc4",
	"./google.svg": "d950",
	"./hide.svg": "a010",
	"./info.svg": "76ed",
	"./instagram.svg": "bd6c",
	"./link.svg": "40a1",
	"./linkedin.svg": "9ed9",
	"./loading.svg": "1e31",
	"./locate.svg": "66e9",
	"./map-pin-alt.svg": "dd27",
	"./map-pin.svg": "60c5",
	"./medal.svg": "81c3",
	"./menu.svg": "d17f",
	"./mobile-unlock.svg": "0c56",
	"./mobile.svg": "0df4",
	"./money.svg": "cf44",
	"./moon.svg": "0190",
	"./muted.svg": "02df",
	"./nfe.svg": "37f6",
	"./note.svg": "f079",
	"./notify.svg": "c760",
	"./package-delivery-alt.svg": "91b0",
	"./package-delivery.svg": "cbca",
	"./package-request-fail.svg": "b1c2",
	"./package-request.svg": "7a9f",
	"./package-volume.svg": "82cb",
	"./package.svg": "d07a",
	"./pdf.svg": "5730",
	"./pending.svg": "e25a",
	"./photo-alt.svg": "b3db",
	"./photo.svg": "7e86",
	"./pin-check.svg": "0856",
	"./pin-uncheck.svg": "8e52",
	"./pin.svg": "862b",
	"./print.svg": "671e",
	"./profile-driver.svg": "5f3d",
	"./profile.svg": "95dc",
	"./refresh.svg": "53fa",
	"./remove.svg": "5088",
	"./report.svg": "effc",
	"./rg.svg": "7f3c",
	"./rocket.svg": "6f49",
	"./rote-add.svg": "2cd9",
	"./rote.svg": "b38b",
	"./save.svg": "9344",
	"./search.svg": "d103",
	"./settings.svg": "9174",
	"./show.svg": "b65e",
	"./signature.svg": "c2c7",
	"./status-alt.svg": "09bd",
	"./status-bad.svg": "a6f6",
	"./status.svg": "c10e",
	"./stock.svg": "2f620",
	"./store-alt.svg": "8e42",
	"./store.svg": "e29b",
	"./success.svg": "1c27",
	"./sun.svg": "3961",
	"./trash.svg": "af22",
	"./truck-delivered.svg": "0535",
	"./truck-delivery.svg": "4315",
	"./truck-document.svg": "7d5d",
	"./truck-ds-alt.svg": "4b1b",
	"./truck-ds.svg": "1906",
	"./truck-location.svg": "0175",
	"./truck-ongoing.svg": "fcbf",
	"./truck-plate-alt.svg": "5573",
	"./truck-plate.svg": "b20f",
	"./truck-question.svg": "c3bc",
	"./truck-remove.svg": "0ed4",
	"./truck.svg": "e5ca",
	"./unlink.svg": "73a1",
	"./unmuted.svg": "5000",
	"./upload-alt.svg": "8f9d",
	"./upload.svg": "5a96",
	"./user.svg": "6aed",
	"./whatsapp.svg": "7583",
	"./xml.svg": "3273"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";